import styled from '@emotion/styled'

export const ActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
`

export const RecoveryTip = styled.p`
  margin-bottom: 20px;
`

export const ButtonWrapper = styled.div`
  margin-bottom: 20px;
  text-align: center;
`
